import { useQuery } from 'react-query';

import { communityFeedApi } from 'src/Services/API';
import { CommunityFeedItemDto } from 'src/Services/API/generated';

const useFetchSingleFeedItem = (postId: string) => {
  return useQuery<CommunityFeedItemDto>({
    queryKey: ['fetch-community-feed-item', postId],
    queryFn: async () => {
      return (await communityFeedApi.communityFeedControllerGetFeedItemById(postId)).data;
    },
    enabled: !!postId,
  });
};

export default useFetchSingleFeedItem;
